import React from "react";
import { Clock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { pendingApprovalTestIds } from "../testids/authTestIds";
import { APP_BASE } from "../lib/utils";

export function PendingApprovalPage(): React.ReactElement {
  const { pendingMemberships, logout } = useAuth();

  const orgNames = pendingMemberships
    .map((m) => m.accountName)
    .filter(Boolean);

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen bg-background gap-4 p-6"
      data-testid={pendingApprovalTestIds.page}
    >
      <div
        className="max-w-md text-center bg-card rounded-xl p-8 border border-border"
        data-testid={pendingApprovalTestIds.card}
      >
        {/* `hsl(var(--primary))` was a shadcn-ism: --primary here is a whole
            colour, not an HSL triplet, so the stroke was invalid and the icon
            never drew. */}
        <div className="mb-4 flex justify-center">
          <Clock size={48} strokeWidth={1.5} className="text-muted-foreground" />
        </div>
        <h2
          className="text-xl font-semibold text-foreground mb-2"
          data-testid={pendingApprovalTestIds.heading}
        >
          Pending Approval
        </h2>
        <p
          className="text-sm text-muted-foreground leading-relaxed"
          data-testid={pendingApprovalTestIds.message}
        >
          {orgNames.length > 0
            ? `Your request to join ${orgNames.join(", ")} is pending approval from an administrator.`
            : "Your account access is pending approval from an administrator."
          }
        </p>
        <p
          className="text-xs text-muted-foreground mt-4"
          data-testid={pendingApprovalTestIds.hint}
        >
          You'll get full access once approved. In the meantime, you can use your personal organization.
        </p>

        <div className="flex flex-col gap-3 mt-6">
          <Button
            variant="default"
            onClick={() => window.location.href = APP_BASE}
            data-testid="pending-continue-btn"
          >
            Continue to personal organization
          </Button>
          <Button
            variant="outline"
            onClick={logout}
            data-testid={pendingApprovalTestIds.signOutButton}
          >
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
